import { Component, OnInit, ViewChild } from '@angular/core';
import { DiscountGroupService } from 'src/app/services/http/business/discount-group/discount-group.service';
import { MatTableDataSource, MatPaginator, MatDialog, MatSelect } from '@angular/material';
//import { Router } from '@angular/router';
import { CIDService } from 'src/app/services/common/cid.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
//import { ErrorsService } from 'src/app/services/common/errors.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
//import { EntryClassDiscountGroupComponent } from '../entry-class-discount-group/entry-class-discount-group.component';
//import { EntryNonClassDiscountGroupComponent } from '../entry-non-class-discount-group/entry-non-class-discount-group.component';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { ICompany } from 'src/app/interfaces/company';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { DiscountPersonAddDocumentComponent } from '../discount-person-add-document/discount-person-add-document.component';

@Component({
  selector: 'app-discount-person-list',
  templateUrl: './discount-person-list.component.html',
  styleUrls: ['./discount-person-list.component.css']
})
export class DiscountPersonListComponent implements OnInit {

  compnayList: ICompany[];
  isOwner: boolean;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "title",
    "discountPercent",
    "discountGroupType",
    "status",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;

  constructor(
    //private router: Router,
    private dialog: MatDialog,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    public translate: TranslateService,
    private discountGroupService: DiscountGroupService
    //    private errorService: ErrorsService
  ) { }

  ngOnInit() {
    this.checkOwner();

  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  list() {
    this.discountGroupService.listPersonDocument(1, 10).subscribe(
      res => {
        console.log(res);
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.listShow", {
            name: this.translate.get("label.discountGroup")
          }),
          "OK",
          5000,
          SoundEnum.beep
        );
      }
    );
  }


  ative(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.discountGroup") + " " + "'" + data.Title + "'"
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.discountGroup") + " " + "'" + data.Title + "'"
        }),
        alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: data.Id,
        IsActive: !data.IsActive
      };
      if (result) {

        this.discountGroupService.activeDeactive(model).subscribe(
          () => {
            if (!model.IsActive) {
              this.snackBar.OpenSnackBar(
                this.translate.get("success.deactiveDiscountGroup"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            else {
              this.snackBar.OpenSnackBar(
                this.translate.get("success.activeDiscountGroup"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            this.referesh();
          },
          () => {
            if (!model.IsActive) {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.deactiveDiscountGroup"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            else {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.activeDiscountGroup"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
          }
        );
      }
    });
  }

  // private referesh() {
  //   this.discountGroupService
  //     .list(this.pageIndex + 1, this.pageSize)
  //     .subscribe(res => {
  //       this.dataSource = new MatTableDataSource(res.DataList);
  //     });
  // }

  delete(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.discountGroup") + " " + "'" + data.Title + "'"
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: data.Id
      };
      if (result) {
        this.discountGroupService.delete(model).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.deleteDiscountGroup"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.referesh();
          },
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("error.deleteDiscountGroup"),
              "ok",
              5000,
              SoundEnum.beep
            );
            //this.errorService.transactionError();
          }
        );
      }
    });
  }



  paginatorEvent(event) {
    this.discountGroupService
      .listPersonDocument(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  addPersonDiscount() {
    this.dialog
      .open(DiscountPersonAddDocumentComponent, {
        maxWidth: "400px"
      })
      .afterClosed()
      .subscribe(() => {
        this.referesh();
      });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.list();
  }


  referesh() {
    this.discountGroupService.listPersonDocument(this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
    });
  }

}
